module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="ads-container">\n	<div id="league-manage-ad-slot-1"></div>\n	<script type="text/javascript">\n		if ( window.googletag ) {\n			window.googletag.cmd.push( function () {\n				window.googletag.display( \'league-manage-ad-slot-1\' );\n			} );\n		}\n	</script>\n</div>\n<div class="news-block"></div>';
}
return __p;
};
